(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    const closeButton = event.target.closest('.mobile-menu__close');
    if (closeButton) closeButton.closest('.mobile-menu').removeAttribute('open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    const link = event.target.closest('.whatsapp-order');
    if (!link) return;
    const box = link.closest('.order-box');
    const variant = box.querySelector('[name="contact[variante]"]');
    const quantity = box.querySelector('[name="contact[quantite]"]');
    const selected = variant && variant.options ? variant.options[variant.selectedIndex] : null;
    const variantName = variant ? variant.value : '';
    const price = selected ? selected.dataset.price : '';
    const message = `Bonjour Xalérie, je souhaite commander : ${link.dataset.product}${variantName ? `\nOption : ${variantName}` : ''}${price ? `\nPrix : ${price}` : ''}\nQuantité : ${quantity ? quantity.value : 1}\n${link.dataset.url}`;
    link.href = `https://wa.me/${link.dataset.number}?text=${encodeURIComponent(message)}`;
  });

  } catch(e) { console.error(e); }
})();
})();
